export const WebRoutes = {
  home: "/",
  dashboard: "/",
  map: "/map",
  reports: "/reports",
  gantt: "/gantt",
  directory: "/directory",
  workplaceRequests: "/workplace-requests",
  tessa: "/tessa"
};
